export default __webpack_public_path__ + "static/media/miguel-lopes-39.fedb209a.jpg";